module.exports = __webpack_public_path__ + "media/images/orion_pictos/couch-93b8031c5b08bfee2bd41982570c9472.svg";